type AuthChange = { type: "signed-in" | "signed-out" }
type Listener = (event: AuthChange) => void

const listeners = new Set<Listener>()
const channel =
  typeof BroadcastChannel === "undefined"
    ? null
    : new BroadcastChannel("merrin.auth")

channel?.addEventListener("message", (event: MessageEvent<AuthChange>) => {
  for (const listener of listeners) {
    listener(event.data)
  }
})

export function onAuthChange(listener: Listener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function notifySignedIn(): void {
  channel?.postMessage({ type: "signed-in" } satisfies AuthChange)
}

export function notifySignedOut(): void {
  channel?.postMessage({ type: "signed-out" } satisfies AuthChange)
}
